import { formatMinutesAsHoursAndMinutes } from '~/utils/date/duration';

const format = (value: number, minimumFractionDigits: number): string =>
  value.toLocaleString('en-US', { minimumFractionDigits, maximumFractionDigits: 2 });

const formatDollarAmount = (dollars: number): string =>
  format(dollars, Number.isInteger(dollars) ? 0 : 2);

export const formatDollars = (dollars: number): string => `$${formatDollarAmount(dollars)}`;

export const formatEntryAmount = (
  minutesWorked: number | null,
  currencyEarned: number | null,
): string =>
  [
    minutesWorked !== null && formatMinutesAsHoursAndMinutes(minutesWorked),
    currencyEarned !== null && `$ ${formatDollarAmount(currencyEarned)}`,
  ]
    .filter(Boolean)
    .join(' + ');
